<auto-main-navigation [accountId]="accountId.toString()"></auto-main-navigation>
<p-panel>
  <ng-template #header>
    <div class="settings-header-wrapper">
      <h1 class="settings-header">MPOP Settings</h1>
    </div>
  </ng-template>
  <div class="main-content-wrapper p-grid">
    <div class="p-col-3">
      <p-panelMenu [model]="settingsSideNav">
      </p-panelMenu>
    </div>
    <p-panel class="p-col ad-types-wrapper">
      <ng-template #header>
        <div class="ad-types-header-wrapper">
          <h2 class="setting-name">Cruise Control</h2>
        </div>
      </ng-template>
      <p-tabs [value]="0">
        <p-tablist>
          <p-tab [value]="0">New</p-tab>
          <p-tab [value]="1">Used</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0">
            @if (newSettings) {
              <auto-cruise-control-form [accountId]="accountId" [settings]="newSettings" label="New" />
            }
          </p-tabpanel>
          <p-tabpanel [value]="1">
            @if (usedSettings) {
              <auto-cruise-control-form [accountId]="accountId" [settings]="usedSettings" label="Used" />
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
      <p-confirmDialog #cd>
        <ng-template #headless let-message>
          <div class="surface-overlay">
            <div class="popup-icon">
              <i [class]="message.icon"></i>
            </div>
            <span class="popup-title">
                {{ message.header }}
              </span>
            <p class="popup-message">You are about to run Cruise Control automation to build offer sets for <span class="popup-vehicle-condition p-badge-warning">{{message.message}}</span> vehicles. <br/><br/> Do you wish to proceed?</p>
            <div class="popup-buttons">
              <p-button
                label="Cancel"
                (click)="cd.onReject()"
                variant="outlined"
                class="w-8rem ">
              </p-button>
              <p-button
                label="Run"
                (click)="cd.onAccept()"
                class="w-8rem">
              </p-button>
            </div>
          </div>
        </ng-template>
      </p-confirmDialog>
    </p-panel>
  </div>
</p-panel>
<auto-footer></auto-footer>
